import { render, staticRenderFns } from "./recycleDialog.vue?vue&type=template&id=4023ed3c"
import script from "./recycleDialog.vue?vue&type=script&lang=js"
export * from "./recycleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4023ed3c')) {
      api.createRecord('4023ed3c', component.options)
    } else {
      api.reload('4023ed3c', component.options)
    }
    module.hot.accept("./recycleDialog.vue?vue&type=template&id=4023ed3c", function () {
      api.rerender('4023ed3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/customPrintNewReconsitution/components/recycleDialog.vue"
export default component.exports